import { jsx } from 'react/jsx-runtime';
import { useContext, useCallback } from 'react';
import { Dropdown } from '../../Dropdown/Dropdown.es.js';
import { FilterGroupContent } from '../FilterGroup.Content/FilterGroup.Content.es.js';
import { FilterGroupContext } from '../FilterGroup.Context/context.es.js';

const FilterDropdown = ({ name, items, onChange, variant = 'default', self, ...props })=>{
    const { filters, setFilter } = useContext(FilterGroupContext);
    const handleChange = useCallback((item)=>{
        setFilter(name, item.value, self);
        onChange?.(item);
    }, [
        name,
        onChange,
        self,
        setFilter
    ]);
    return jsx(FilterGroupContent, {
        id: name,
        children: jsx(Dropdown, {
            ...props,
            className: "cb-filter-group-dropdown",
            "data-testid": `filter-group-dropdown-${name}`,
            intent: "filter",
            items: items,
            onChange: handleChange,
            value: filters?.[name],
            variant: variant,
            children: jsx(Dropdown.Options, {
                items: items
            })
        })
    });
};
FilterDropdown.displayName = 'FilterGroup.Filters.Dropdown';

export { FilterDropdown };
//# sourceMappingURL=FilterGroup.Dropdown.es.js.map
